var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.config)?_c(_setup.SChipBasic,{attrs:{"size":"small","icon":_setup.config.icon,"text":_setup.config.text,"color":_setup.config.color,"text-color":_setup.config.textColor}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }